import { getApiBaseUrl, normalizeApiEndpoint } from '../config';

/** Absolute URL for raw `fetch()` (split-host: tyly/poligon; dev: same-origin `/api`). */
export function buildApiUrl(endpoint) {
  const path = normalizeApiEndpoint(endpoint);
  const base = (getApiBaseUrl() || '').trim().replace(/\/$/, '');
  if (!base) {
    return path;
  }
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}
